import { ReactSDKClient } from '@optimizely/react-sdk'
import { Experiments } from 'OptimizelyProvider'
import RootStore from 'stores/RootStore'
import { getOptimizelyTrackingAttribute } from '..'

export function getUserExperimentsAndVariations(
  optimizelyClient: ReactSDKClient,
  experiments: Experiments[],
  userId: string,
  rootStore: RootStore
) {
  const runningExperiments = []
  const runningVariations = []
  const segmentTrackingObject = {}

  for (let i = 0; i < experiments.length; i += 1) {
    const variation = optimizelyClient.getVariation(experiments[i], userId, {
      ...getOptimizelyTrackingAttribute(rootStore)
    })
    if (variation) {
      runningVariations.push(`${variation}_${experiments[i]}}`)

      runningExperiments.push(experiments[i])

      segmentTrackingObject[experiments[i].split('_')[0].toLowerCase()] = {
        experimentVariationKey: `${experiments[i]} | ${variation}`,
        userId
      }
    }
  }

  return {
    runningExperiments,
    runningVariations,
    segmentTrackingObject
  }
}
